import { render, staticRenderFns } from "./login-main.vue?vue&type=template&id=d8cf635e&lang=pug&"
import script from "./login-main.vue?vue&type=script&lang=js&"
export * from "./login-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports